import { useQuery } from '@tanstack/react-query';
import { getReportFields } from '../requests/report.request';
import { ReportEntityType, ReportFieldMetadata } from '../types/report.types';
import toast from 'react-hot-toast';

interface IReportFieldsQueryOptions {
  entityType: ReportEntityType;
  enabled?: boolean;
}

export const useReportFieldsQuery = ({ entityType, enabled = true }: IReportFieldsQueryOptions) => {
  return useQuery<ReportFieldMetadata[]>({
    queryKey: ['report-fields', entityType],
    queryFn: () => getReportFields(entityType),
    enabled,
    retry: 2,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    onError: () => {
      toast.error("Couldn't fetch report fields", { id: 'report-fields-error' });
    }
  });
};
